import CardPlacingOrder from '@/entities/cart-page/CardPlacingOrder'
import {
    changeAreaType,
    changeCurrentStep,
    changePaymentMethodValue,
    changeShippingMethodValue,
    updateArea,
} from '@/shared/store/slice/cartSlice'
import classNames from 'classnames'
import { useState } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { changeAreaZodeId } from '@/shared/store/slice/cartSlice'

export const Area = ({userInfo}) => {
    const {
        area: data,
        areaType,
        areaZoneId,
        currentStep: step,
    } = useSelector((state) => state.cartActions)

    const dispatch = useDispatch()

    const handleAreaChange = (type, zoneId, e) => {
        // Сначала сбрасываем все данные, связанные с доставкой
        dispatch(changeShippingMethodValue(null))
        dispatch(changePaymentMethodValue(null))
        
        // Затем устанавливаем новый тип
        dispatch(changeAreaType(type))
        dispatch(changeAreaZodeId(zoneId))
        dispatch(changeCurrentStep(1))
    }

    const handleUpdateArea = (e) => {
        dispatch(
            updateArea({
                area: areaType,
                area_another: areaType === 'another' ? areaType : null,
                userInfo
            })
        )
    }

    return (
        <CardPlacingOrder
            stepTitle={'Шаг 1: Зона доставки'}
            currentStep={step === 1}
            changeStep={handleUpdateArea}
            className={step >= 1 ? 'active' : ''}
            textButton={'Следующий шаг'}
            isValid={
                (areaType && areaType !== 'another') ||
                (areaType && areaZoneId && areaZoneId !== 'unchoisen')
            }
        >
            <h3>Выберите город получения доставки:</h3>

            <InputGroup>
                <Form.Check
                    id={'city-1'}
                    type={'radio'}
                    checked={areaType === 'msk.inside-mkad'}
                    name="shipping_area"
                    onChange={(e) => {
                        handleAreaChange('msk.inside-mkad', 176, e)
                    }}
                />
                <label htmlFor="city-1">
                    <span>Москва (внутри МКАД)</span>
                </label>
            </InputGroup>

            <InputGroup>
                <Form.Check
                    id={'city-3'}
                    type={'radio'}
                    name="shipping_area"
                    onChange={(e) => {
                        handleAreaChange('spb.inside-kad', 106, e)
                    }}
                    checked={areaType === 'spb.inside-kad'}
                />
                <label htmlFor="city-3">
                    <span>Санкт-Петербург (внутри КАД)</span>
                </label>
            </InputGroup>

            <InputGroup>
                <Form.Check
                    id={'city-4'}
                    type={'radio'}
                    name="shipping_area"
                    onChange={(e) => {
                        handleAreaChange('another', 169, e)
                    }}
                    checked={areaType === 'another'}
                />
                <label htmlFor="city-4">
                    <span>Другой город</span>
                </label>
            </InputGroup>
        </CardPlacingOrder>
    )
}